import { Component } from '@angular/core';

@Component({
    selector: 'app-trial-expired',
    templateUrl: './trial-expired.component.html',
    styleUrls: ['./trial-expired.component.css'],
    standalone: true,
})
export class TrialExpiredComponent {
    constructor() {}
}
